module.exports = __webpack_public_path__ + "static/media/loginImg1.be4e022b.png";